"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagDZ = function FlagDZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.07,7.07,0,0,1-7.06,7.06H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M45.89-13.5l-12.25,16L14.52-3.88A1.17,1.17,0,0,0,13.19-2.1L24.64,14.5l-12,16.2a1.17,1.17,0,0,0,1.28,1.82l19.32-5.76L45,43.18a1.17,1.17,0,0,0,2.12-.66l.49-20.15,19.23-6.06a1.18,1.18,0,0,0,0-2.23l-19-6.69L48-12.77a1.17,1.17,0,0,0-2.1-.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.49,60.68a48.5,48.5,0,0,1,0-97,47.58,47.58,0,0,1,26.8,8.24,1.17,1.17,0,0,0,1.53-1.76A60.09,60.09,0,0,0,7.24-48.38,60.88,60.88,0,0,0-51.1,8.19,60.59,60.59,0,0,0,9.34,72.77,60.11,60.11,0,0,0,52.86,54.16a1.16,1.16,0,0,0-1.53-1.74,47.55,47.55,0,0,1-26.84,8.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagDZ;
exports["default"] = _default;